import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  Select,
  Flex,
  Typography,
  message,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import commonFn from "@/utils/commonFn";
import api from "@/utils/api";
import http from "@/utils/http";

export default function AddMenuModal({
  open,
  onCancel,
  parentRecord, 
  currentRecord, 
  onSuccess,
}) {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const [loading, setLoading] = useState(false);

  const iconOptions = [
    { value: "CreditCardOutlined", label: "CreditCardOutlined" },
    { value: "FileTextOutlined", label: "FileTextOutlined" },
    { value: "PieChartOutlined", label: "PieChartOutlined" },
    { value: "ApartmentOutlined", label: "ApartmentOutlined" },
    { value: "TeamOutlined", label: "TeamOutlined" },
  ];


  useEffect(() => {
    if (open) {
      form.resetFields();
      if (currentRecord) {
        form.setFieldsValue(currentRecord);
      }
    }
  }, [open, currentRecord]);


  const onFinish = async (values) => {
    setLoading(true);

    const parentMenuId =
      values.type === "1"
        ? "0"
        : parentRecord?.menuId || "0"; 

    const queryParams = {
      parentMenuId,
      menuName: values.menuName,
      menuUrl: values.menuUrl,
      type: values.type,
      sort: values.sort,
      display: values.display,
      remark: values.remark,
      menuIcon: values.menuIcon,
      permissionPath: values.permissionPath,
    };

    const response = await http.post(api.getSaveMenu, queryParams);

    setLoading(false);

    if (response?.code === "1") {
      message.success("Add menu successfully.");
      onSuccess();
      form.resetFields();
    } else {
      commonFn.modalFailedFn(response);
    }
  };

  return (
    <Modal
      width="50%"
      open={open}
      maskClosable={false}
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            ADD MENU
          </Typography.Title>
        </Flex>
      }
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </div>}
      onCancel={onCancel}
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Form
              form={form}
              onFinish={onFinish}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 16 }}
            >
              <Form.Item
                name="menuName"
                label="Name"
                rules={[{ required: true }]}
              >
                <Input allowClear placeholder="Please enter a Name." />
              </Form.Item>

              <Form.Item
                name="menuUrl"
                label="Menu Url"
                rules={[{ required: true }]}
              >
                <Input allowClear placeholder="Please enter Menu Url." />
              </Form.Item>

              <Form.Item
                name="type"
                label="Type"
                rules={[{ required: true }]}
              >
                <Select>
                  <Select.Option value="1">Directory</Select.Option>
                  <Select.Option value="2">Menu</Select.Option>
                  <Select.Option value="3">Button</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item
                name="display"
                label="Display"
                rules={[{ required: true }]}
              >
                <Select>
                  <Select.Option value="1">Yes</Select.Option>
                  <Select.Option value="2">No</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item name="sort" label="Sort">
                <Input type="number" allowClear placeholder="Sort number" />
              </Form.Item>

              <Form.Item name="remark" label="Remark">
                <Input allowClear placeholder="Remark" />
              </Form.Item>

              <Form.Item name="menuIcon" label="Menu Icon">
                <Select optionLabelProp="label">
                  {iconOptions.map((i) => (
                    <Select.Option key={i.value} value={i.value} label={i.label}>
                      {commonFn.iconDocFn(i.value)} {i.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item name="permissionPath" label="Permission Path">
                <TextArea />
              </Form.Item>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
}
